import React from "react";
import {PageHeader} from "./PageHeader";
import logocittru from "../img/organizers/logo-si-cittru.png";
import logocctagh from "../img/organizers/logo-si-cctagh.png";
import logokrakow from "../img/organizers/logo-si-krakow.png";
import logomarr from "../img/organizers/logo-si-marr.png";
import logopactt from "../img/organizers/logo-si-pactt.png";

export const Innowacje2 = props => {
    var imgStyle = {
        padding: '5px',
        margin: '5px',
        width: '200px'
    }
    return (
        <React.Fragment>
            <PageHeader title="Fizyka - Przemysł - Innowacje"/>
            <div className="content-wrapper">
                <div className="main-content row innowacje">
                    <div className="col-9 text-justify">

                        <h2> Słowo wstępne</h2>
                        <p>
                            Dzięki wieloletniej współpracy pomiędzy Centrum Transferu Technologii CITTRU
                            Uniwersytetu Jagiellońskiego, Centrum Transferu Technologii AGH oraz
                            ogólnopolskiej sieci Porozumienie Akademickich Centrów Transferu Technologii
                            w trakcie tegorocznego Zjazdu Fizyków Polskich odbędzie się specjalna sesja
                            „FizykaPrzemysł-Innowacje”. Sesja ta jest odpowiedzią na rosnące zainteresowanie rynku na
                            nowe rozwiązania opracowywane przez środowiska naukowe, które mogą znaleźć
                            zastosowanie, zarówno w skomplikowanych procesach technologicznych, jak
                            i codziennym życiu. Mamy nadzieję, że inicjatywa ta pomoże zintensyfikować
                            współpracę pomiędzy jednostkami naukowymi, a firmami działającymi w obszarze
                            nowoczesnych technologii.
                            W trakcie sesji swoje wystąpienia będą mieli naukowcy, przedstawiciele biznesu
                            i samorządów. Uczeni będą prezentować nie tylko swoje najnowsze wynalazki, ale
                            także możliwości wykorzystania unikatowego zaplecza badawczego do świadczenia
                            komercyjnych usług na rzecz przedsiębiorców. Przedsiębiorcy natomiast będą mówili
                            o swoich osiągnieciach oraz zapotrzebowaniu na usługi badawczo-rozwojowe.
                            W ramach tej dwudniowej sesji na szczególną uwagę zasługuje panel "Innowacje
                            technologiczne w mieście XXI wieku", zorganizowany we współpracy z Urzędem
                            Miasta Krakowa, a szczególności jego Wydziałem ds. Przedsiębiorczości i Innowacji.
                            Panel ten będzie poświęcony współpracy na linii nauka-przemysł-samorząd
                            i wdrażaniu rezultatów prac badawczo-rozwojowych w szczególny sposób służących
                            społeczeństwu i poprawie komfortu życia w mieście. Na przykładzie działań
                            podejmowanych w Mieście Krakowie pokazana zostanie ważna rola jaką nauka ma
                            do spełnienia w nowoczesnym mieście.
                            Liczymy, że sesja „Fizyka-Przemysł-Innowacje” nie tylko zainspiruje uczestników 45.
                            Zjazdu Fizyków Polskich do ożywionej i owocnej dyskusji oraz współpracy, ale także
                            na stałe zagości w programach kolejnych Zjazdów.
                        </p>
                    </div>
                    <div className="col-3">
                        <div className="sidebar">
                            <span className="sidebar-header text-center"> Partnerzy sesji</span>
                            <p>
                                <a href="https://business.krakow.pl/" rel="noopener noreferrer"><img alt="citru" src={logokrakow} style={imgStyle}/></a>
                                <br/>
                                <a href="http://www.cittru.uj.edu.pl/"><img alt="citru" src={logocittru} style={imgStyle}/></a>
                                <br/>
                                <a href="http://www.ctt.agh.edu.pl/"><img alt="citru" src={logocctagh} style={imgStyle}/></a>
                                <br/>
                                <a href="http://pactt.pl/"><img alt="citru" src={logopactt} style={imgStyle}/></a>
                                <br/>
                                <a href="https://www.marr.pl/"><img alt="citru" src={logomarr} style={imgStyle}/></a>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="main-content innowacje">

                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12">
                            <br/>
                            <h4 className="h4">Poniedziałek, 16 września 2019 r. (D10-A, Akademia
                                Górniczo-Hutnicza)</h4>
                            <table className="table table-striped sinn">
                                <thead>
                                <tr>
                                    <th>Godzina</th>
                                    <th>Tytuł</th>
                                    <th>Wykładowca</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>15:00 - 15:30</td>
                                    <td>Neuronowe modele prognozy zanieczyszczeń pyłami zawieszonymi PM10</td>
                                    <td>Piotr Kowalski</td>
                                </tr>
                                <tr>
                                    <td>15:30 - 16:00</td>
                                    <td>Od badań materiałów do bezinwazyjnego pomiaru zawartości glukozy we krwi</td>
                                    <td>Konstanty Marszałek</td>
                                </tr>
                                <tr>
                                    <td>16:00 - 16:20</td>
                                    <td>Dlaczego Fizyk, to dobry materiał na odlewnika metali nieżelaznych</td>
                                    <td>Michał Łuszczak</td>
                                </tr>
                                <tr>
                                    <td>16:20 - 16:40</td>
                                    <td>Nowa perspektywa finansowa a skala i standard badań dla przemysłu</td>
                                    <td>Grzegorz Putynkowski</td>
                                </tr>
                                <tr>
                                    <td>16:40 - 17:00</td>
                                    <td>Fizyka w innowacjach technologicznych PZL Mielec</td>
                                    <td>Tomasz Gałaczyński <br/>Bogdan Ostrowski</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12">
                            <br/>
                            <h4 className="h4">Wtorek, 17 września 2019 r. (A-1-13, Wydz. Fizyki, Astronomii i
                                Informatyki Stos. UJ)</h4>
                            <table className="table table-striped sinn">
                                <thead>
                                <tr>
                                    <th>Godzina</th>
                                    <th>Tytuł</th>
                                    <th>Wykładowca</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>11:30 - 11:45</td>
                                    <td>Uniwersytecka sieć detektorów monitorująca jakość powietrza
                                        TymOddycham.uj.edu.pl
                                    </td>
                                    <td>Zenon Nieckarz</td>
                                </tr>
                                <tr>
                                    <td>11:45 - 12:00</td>
                                    <td>Kraków, miastem sprzyjającym wdrażaniu nowych technologii</td>
                                    <td>Katarzyna Wysocka</td>
                                </tr>
                                <tr>
                                    <td>12:00 - 12:15</td>
                                    <td>Współpraca Wydziału Fizyki i Informatyki Stosowanej AGH z Urzędem Miasta w
                                        zagadnieniach związanych z jakością powietrza w Krakowie
                                    </td>
                                    <td>Mirosław Zimnoch</td>
                                </tr>
                                <tr>
                                    <td>12:15 - 12:30</td>
                                    <td>Innowacyjna infrastruktura Wodociągów Miasta Krakowa</td>
                                    <td>Tadeusz Bochnia</td>
                                </tr>
                                <tr className="alert-warning">
                                    <td>12:30 - 13:30</td>
                                    <td><b>Panel dyskusyjny: "Innowacje technologiczne w mieście XXI wieku"</b><br/>
                                        <i>Paneliści:</i>
                                        <ul>
                                            <li>Gabriela Konopka-Cupiał (CITTRU Uniwersytet Jagielloński),</li>
                                            <li>Sławomir Kopeć (Akademia Górniczo-Hutnicza),</li>
                                            <li>Paweł Węgrzyn (Uniwersytet Jagielloński),</li>
                                            <li>Katarzyna Wysocka (Wydział ds. Przedsiębiorczości i Innowacji Urzędu
                                                Miasta Krakowa)
                                            </li>
                                        </ul>
                                        <i>Moderator:</i> Agata Błaszczyk-Pasteczka (CITTRU Uniwersytet Jagielloński),
                                    </td>
                                    <td></td>
                                </tr>
                                <tr className="alert-primary">
                                    <td>13:30- 15:00</td>
                                    <td className="text-center">Przerwa obiadowa</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>15:00 - 15:15</td>
                                    <td>Materiały tlenkowe w nowej generacji przyrządów elektro-nicznych,
                                        optoelektronicznych i w diagnostyce medycznej
                                    </td>
                                    <td>Rafał Pietruszka</td>
                                </tr>
                                <tr>
                                    <td>15:15 - 15:30</td>
                                    <td>Zastosowanie metody pulse-mixing do bezwzględnych pomiarów aktywności
                                        radionuklidów techniką ciekłych scyntylatorów
                                    </td>
                                    <td>Tomasz Ziemek</td>
                                </tr>
                                <tr>
                                    <td>15:30 - 15:45</td>
                                    <td>Synteza wysokiej jakości grafenu na powierzchni węglika krzemu</td>
                                    <td>Piotr Ciochoń</td>
                                </tr>
                                <tr>
                                    <td>15:45 - 16:00</td>
                                    <td>Zasady programu ministra nauki i szkolnictwa wyższego pn. doktorat wdrożeniowy
                                    </td>
                                    <td>Aneta Fausek</td>
                                </tr>
                                <tr>
                                    <td>16:00 - 16:20</td>
                                    <td>“Data hold the answer” czyli o czyli o działalności Project42, spółki spin-off
                                        Uniwersytetu Warszawskiego
                                    </td>
                                    <td>Maciej Ciemny</td>
                                </tr>
                                <tr>
                                    <td>16:20 - 16:35</td>
                                    <td>Ciekłe kryształy w budownictwie -stan obecny, perspektywy, problemy.</td>
                                    <td>Witold Nawrot</td>
                                </tr>
                                <tr>
                                    <td>16:35 - 16:45</td>
                                    <td>Wystąpienie przedstawiciela MARR: Małopolska Agencja Rozwoju Regionalnego S.A.
                                    </td>
                                    <td>/tba/</td>
                                </tr>
                                <tr>
                                    <td>16:45 - 17:00</td>
                                    <td>Wielkopowierzchniowa metoda tworzenia cienkich warstw z wykorzystaniem
                                        przesuwanego menisku
                                    </td>
                                    <td>Jakub Rysz</td>
                                </tr>
                                <tr className="alert-primary">
                                    <td>17:00 - 17:30</td>
                                    <td className="text-center">Przerwa kawowa</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>17:30 - 17:45</td>
                                    <td>Nieinwazyjne wykrywanie materiałów niebezpiecznych w wodzie: projekt SABAT</td>
                                    <td>Michał Silarski</td>
                                </tr>
                                <tr>
                                    <td>17:45 - 18:00</td>
                                    <td>Elektrociepłownie lokalne opalane biomasą - etap wstępny do elektrociepłowni
                                        jądrowej z reaktorem wysokotemperaturowym.
                                    </td>
                                    <td>Mieczysław Dziura</td>
                                </tr>
                                <tr>
                                    <td>18:00 - 18:15</td>
                                    <td>Projekt cewki z wolframu chłodzonego ciekłym helem do wytwarzania silnych
                                        jednorodnych pól magnetycznych
                                    </td>
                                    <td>Stanisław Bednarek</td>
                                </tr>
                                <tr>
                                    <td>18:15 - 18:30</td>
                                    <td>Przetwarzanie ekstremalnie dużej ilości danych w eksperymencie ALICE w CERN</td>
                                    <td>Jacek Otwinowski</td>
                                </tr>
                                <tr>
                                    <td>18:30 - 18:50</td>
                                    <td>Synchrotron dla przemysłu</td>
                                    <td>Tomasz Kołodziej</td>
                                </tr>
                                <tr>
                                    <td>18:50 - 19:10</td>
                                    <td>Polish Free-Electron Laser PolFEL</td>
                                    <td>Karolina Szamota - Leandersson</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
Innowacje2.propTypes = {};
